import { Injectable, Inject } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

@Injectable()
export class OktaAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authenticated = await this.oktaAuth.isAuthenticated();
    if (authenticated) {
      return true;
    }
    sessionStorage.setItem("okta-app-url", state.url || this.router.url);

    // Updated to use Authorization Code flow with redirect
    // N.B. this is required to resolve the issue with future deprecation of
    // 3rd party cookies
    this.oktaAuth.signInWithRedirect();

    return false;
  }
}
